export const currentMessaggiVocaliOrigineInitialState = {
  data: {
    customerId: "",
    nngOrigAnnounceId: "",
    nngOrigAnnounceName: "",
    destinationId: "",
    destinationType: "",
    regoleDiApplicazione: "",
    vocalMessagesOriginList: [],
    currentItemList: [],
  },
  loading: false,
};

export const createMessagiVocaliOrigineDataInitialState = {
  data: {
    destinationTypes: [],
    fdnList: [],
    fdnGroupList: [],
    vocalMessagesList: [],
    odrList: [],
    tdrList: [],
    barringList: [],
    messagiVocaliSuBaseOrigineList: [],
    whiteList: [],
    menuServiceList: [],
    nedList: [],
    fileAudioList: [],
    originAreaList: [],
  },
  loading: false,
};
